import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqItems: FAQItem[] = [{
  question: '¿Necesito experiencia para empezar?',
  answer: 'Para nada. Este ebook fue diseñado desde cero para principiantes absolutas. Si podés seguir una receta de cocina, podés seguir estos patrones.'
}, {
  question: '¿Y si ya sé tejer?',
  answer: 'Mejor todavía. Los +60 diseños van de principiante a avanzado. Vas a encontrar técnicas nuevas, ideas de diseño y patrones que todavía no probaste.'
}, {
  question: '¿Cómo recibo el ebook?',
  answer: 'Inmediatamente después de la compra, recibís un email con tu link de descarga. Sin esperas. Sin envío físico.'
}, {
  question: '¿Qué materiales necesito?',
  answer: 'El ebook incluye una guía completa de materiales. Podés empezar con insumos básicos que cuestan menos de $15.'
}, {
  question: '¿Cuánto tiempo lleva hacer la primera bikini?',
  answer: 'La mayoría de las principiantes terminan su primera pieza en 24–48 horas siguiendo el método paso a paso.'
}, {
  question: '¿Puedo vender las bikinis que hago?',
  answer: 'Sí. Una vez que las hacés, son tuyas para usar, regalar o vender.'
}, {
  question: '¿Hay garantía?',
  answer: 'Sí. Garantía de devolución completa de 7 días. Sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-68">
      <div className="max-w-[680px] mx-auto" data-id="element-69">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray text-center mb-10" data-id="element-70">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="divide-y divide-gray-200" data-id="element-71">
          {faqItems.map((item, index) => <div key={index} data-id="element-72">
              <button onClick={() => toggleItem(index)} className="w-full flex items-center justify-between py-5 text-left cursor-pointer group" aria-expanded={openIndex === index} aria-controls={`faq-answer-${index}`} data-id="element-73">
                <span className="font-body font-semibold text-dark-gray text-base md:text-lg pr-4" data-id="element-74">
                  {item.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-pink-dark flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-75" />
              </button>
              <div id={`faq-answer-${index}`} role="region" className={`overflow-hidden transition-all duration-300 ease-out ${openIndex === index ? 'max-h-48 pb-5' : 'max-h-0'}`} data-id="element-76">
                <p className="font-body text-medium-gray text-base leading-relaxed" data-id="element-77">
                  {item.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}